import {tokens as cjsTokens} from './themeContract.cjs.css'
export const tokens = cjsTokens